import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const HomeSkeleton = () => {
    return (
        <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
            {/* 
                Header, Address Bar, and Categories are already rendered by Header and Main components 
                in App.js, so we only need to show skeletons for the content (Combos, Products).
            */}

            {/* Section 1: Combos */}
            <div style={{ marginBottom: '40px' }}>
                <Skeleton width={150} height={30} style={{ marginBottom: '10px' }} /> {/* Title */}
                <Skeleton width={200} height={20} style={{ marginBottom: '20px' }} /> {/* Subtitle */}

                <div style={{ border: '1px solid #eee', borderRadius: '12px', padding: '15px', height: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <Skeleton width={'60%'} height={25} />
                    <Skeleton width={100} height={20} />
                </div>
            </div>

            {/* Section 2: Products */}
            <div>
                <Skeleton width={200} height={30} style={{ marginBottom: '10px' }} /> {/* Title */}
                <Skeleton width={250} height={20} style={{ marginBottom: '20px' }} /> {/* Subtitle */}

                <div style={{ border: '1px solid #eee', borderRadius: '12px', padding: '15px', height: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <Skeleton width={'40%'} height={25} />
                    <Skeleton width={80} height={20} />
                </div>
            </div>
        </div>
    );
};

export default HomeSkeleton;
